import { useResetEditingState } from '@/atoms'
import { RecurrenceSelector } from '@/components/RecurrenceSelector'
import { preview } from '@/components/form/preview'

import { useActions } from './hooks/useActions'
import { useRecurrencesMap } from './hooks/useRecurrencesMap'
import { useTexts } from './hooks/useTexts'

interface Props {
  driverAssignments: Record<string, uui.domain.client.rm.DriverAssignmentsWithId>
  setDriverAssignment: (driverAssignment: uui.domain.client.rm.DriverAssignmentsWithId) => void
}

export function SelectRecurrencePanel(props: Props) {
  const { driverAssignments, setDriverAssignment } = props

  const recurrenceMap = useRecurrencesMap(driverAssignments)
  const texts = useTexts()
  const onCancel = useResetEditingState()
  const { onCreate, onOpenExisting } = useActions(driverAssignments, setDriverAssignment)

  return (
    <preview.Root applyPendingFitMapOnMount>
      <preview.Header
        title={texts.headerTitle}
        subtitle={texts.headerDescription}
        testId="select-recurrence-panel-header"
        onClose={onCancel}
      >
        <preview.ActionBar />
      </preview.Header>
      <RecurrenceSelector
        onCreate={onCreate}
        onOpenExisting={onOpenExisting}
        onCancel={onCancel}
        recurrenceMap={recurrenceMap}
      />
    </preview.Root>
  )
}
